export default __webpack_public_path__ + "static/media/light_mode.4036c710.svg";